import React from 'react';


const Home = () => {

   

    return (
        <div className="container-fluid p-0 mb-5">
        {/* First section with sliding animation */}
        <div className="row" >
            <div className=" position-relative bg-dark text-white py-5" style={{backgroundImage: `url('https://images.pexels.com/photos/16690976/pexels-photo-16690976/free-photo-of-laughing-woman-in-pink-suit-talking-on-phone.jpeg?auto=compress&cs=tinysrgb&w=600')`, backgroundSize: 'cover', backgroundPosition: 'center' ,zIndex: 1,  height: 550}}>
                <div className="position-absolute top-0 start-0 w-100 h-100  opacity-50" style={{ zIndex: -1, backgroundColor: "#FFA500" } }></div>
                <div className="text-left align-left py-5 px-5 " >
                    <h1 className='text-white text-left align-left pt-5 ' style={{ zIndex: 100, marginTop: 13    }}>Metronic Implant</h1>
                    <p className="lead text-left ">Our commitment is to excellence, where we dedicate ourselves entirely and work for it. </p>
                    <div className='pt-2 pb-5'>
                    <a href="/contact">
  <button type="button" className="btn btn-primary mx-2 p-3" style={{ backgroundColor: "#FFA500" }}>Contact us</button>
</a>
                    </div>
                </div>
            </div>
        </div>
      
        {/* Second section with fading animation */}
        <div className="text-white p-5 bg-purple" style={{ backgroundColor: "#581845" }}>
            <div className="container">
                <div className="row justify-content-center py-5">
                    <div className="col-md-6 text-start">
                        <h2 className="text-left text-white  pb-2  text-start">About Us</h2>
                        <p className="text-left text-white  text-start">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed et suscipit neque. Mauris sed nunc ac lorem feugiat placerat. Proin ut bibendum felis. Quisque vel urna a arcu posuere vestibulum non et turpis. Duis nec tortor quam. Suspendisse nec faucibus felis. Nullam eget mi a nunc placerat molestie eget nec lacus. Pellentesque quis eros sed dolor pretium finibus. Donec ultricies, nunc non fermentum molestie, ipsum odio hendrerit elit, id dignissim mi elit vitae lorem.</p>
                        <p className="text-left text-white  pb-2 text-start">Phasellus rutrum arcu nec ex fermentum, nec venenatis leo accumsan. Phasellus non odio dolor. Duis vitae posuere metus. Duis auctor, elit sit amet tempus fermentum, purus orci convallis purus, in placerat turpis lectus in ligula. Fusce vel gravida libero. Duis maximus malesuada nibh, in eleifend purus finibus eget. Pellentesque vitae dolor lectus. Cras venenatis turpis in orci vehicula aliquet.</p>
                        <a href="/services"><button type="button" className="btn btn-secondary p-3 text-start btn-start" style={{  backgroundColor: "#FFA500" } }>Our Service</button></a>
                    </div>
                    <div className="col-md-6 pt-5">
                        <img src="https://images.pexels.com/photos/16603873/pexels-photo-16603873/free-photo-of-lens-on-a-desk.jpeg?auto=compress&cs=tinysrgb&w=600" alt="About" className="img-fluid" />
                    </div>
                </div>
            </div>
        </div>







<div class="bg-light text-dark py-5">

<div className="container  my-5 bg-light">
<h1 className=' my-5'>Services</h1>

    <div className="row">
        <div className="col-md-4 mb-2">
            <div className="card  ">
                <img src="https://images.pexels.com/photos/2672979/pexels-photo-2672979.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" className="card-img-top" alt="Service 1" style={{ height: 260 ,objectFit: 'cover'  }} />
                <div className="card-body">
                    <h5 className="card-title">Economy</h5>
                    <p className="card-text">Phasellus rutrum arcu nec ex fermentum, nec venenatis leo accumsan. Phasellus non odio dolor. Duis vitae posuere metus</p>
                    <a href="/services" className="btn btn-primary" style={{  backgroundColor: "#FFA500" } }>Learn More</a>
                </div>
            </div>
        </div>
        <div className="col-md-4 mb-2">
            <div className="card">
                <img src="https://images.pexels.com/photos/16585156/pexels-photo-16585156/free-photo-of-women-and-men-in-meeting-at-office.jpeg?auto=compress&cs=tinysrgb&w=600" className="card-img-top" alt="Service 2" style={{ height: 260, objectFit: 'cover'  }}/>
                <div className="card-body">
                    <h5 className="card-title">Reflecting</h5>
                    <p className="card-text">Phasellus rutrum arcu nec ex fermentum, nec venenatis leo accumsan. Phasellus non odio dolor. Duis vitae posuere metus</p>
                    <a href="/services" className="btn btn-primary" style={{  backgroundColor: "#FFA500" } }>Learn More</a>
                </div>
            </div>
        </div>
        <div className="col-md-4 mb-2">
            <div className="card">
                <img src="https://images.pexels.com/photos/20450962/pexels-photo-20450962/free-photo-of-two-women-in-an-office-interior-with-shelves.jpeg?auto=compress&cs=tinysrgb&w=600" className="card-img-top" alt="Service 3"style={{ height: 260 , objectFit: 'cover'  }} />
                <div className="card-body">
                    <h5 className="card-title">Standard</h5>
                    <p className="card-text">Phasellus rutrum arcu nec ex fermentum, nec venenatis leo accumsan. Phasellus non odio dolor. Duis vitae posuere metus</p>
                    <a href="/services" className="btn btn-primary" style={{  backgroundColor: "#FFA500" } }>Learn More</a>
                </div>
            </div>
        </div>
    </div>
</div>
</div>
<img
  src="https://images.pexels.com/photos/1181533/pexels-photo-1181533.jpeg?auto=compress&cs=tinysrgb&w=600"
  alt="About"
  className="img-fluid w-100"
  style={{
    height: '400px',
    backgroundAttachment: 'fixed',
    objectFit: 'cover',
    position: 'fixed',

  }}
/>


<div className="text-dark py-5 bg-purple" >

<div class="row justify-content-center py-5 ">
    <div class="col-md-6 p-5  text-start">
        <h2 class="text-left text-dark  pb-2  text-start"> Lorem ipsum
        </h2>
        <p class="text-left text-dark text-start">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed et suscipit neque. Mauris sed nunc ac lorem feugiat placerat. Proin ut bibendum felis. Quisque vel urna a arcu posuere vestibulum non et turpis. Duis nec tortor quam. Suspendisse nec faucibus felis. Nullam eget mi a nunc placerat molestie eget nec lacus. Pellentesque quis eros sed dolor pretium finibus. Donec ultricies, nunc non fermentum molestie, ipsum odio hendrerit elit, id dignissim mi elit vitae lorem.</p>
        <a href="/services">  <button type="button" style={{  backgroundColor: "#FFA500" } } class="btn btn-secondary p-3 text-start btn-start ">Our Service</button></a>
    </div>
    <div class="col-md-6">
        <img src="https://images.pexels.com/photos/392018/pexels-photo-392018.jpeg?auto=compress&cs=tinysrgb&w=600" alt="About" class="img-fluid" />
    </div>
</div>

<div class="row justify-content-center py-5 ">
    <div class="col-md-6  px-5">
        <img src="https://images.pexels.com/photos/3183197/pexels-photo-3183197.jpeg?auto=compress&cs=tinysrgb&w=600" alt="About" class="img-fluid " />
    </div>
    <div class="col-md-6 p-5 text-start">
        <h2 class="text-left text-dark   pb-2  text-start">Lorem ipsum dolor sit amet</h2>
        <p class="text-left text-dark   text-start"> Sed et suscipit neque. Mauris sed nunc ac lorem feugiat placerat. Proin ut bibendum felis. Quisque vel urna a arcu posuere vestibulum non et turpis. Duis nec tortor quam. Suspendisse nec faucibus felis. Nullam eget mi a nunc placerat molestie eget nec lacus. Pellentesque quis eros sed dolor pretium finibus. Donec ultricies, nunc non fermentum molestie, ipsum odio hendrerit elit, id dignissim mi elit vitae lorem.</p>
        <a href="/services">    <button type="button" style={{  backgroundColor: "#FFA500" } } class="btn btn-secondary p-3 text-start btn-start">Our Service</button></a>
    </div>
</div>
</div>
        </div>
    );
}

export default Home;





